import styles from "./InfoPage.module.scss"; // Імпортуємо SCSS файл для стилів
import Nav from "@/components/Header/Nav/Nav";
import Footer from "@/components/Footer/Footer";
// import CookiePopupButton from "@/components/CookieBanner/CookiePopupButton.tsx";
import { useEffect } from "react";
import CookiePopupButton from "../../components/CookieBanner/CookiePopupButton";
import { Helmet } from "react-helmet";

const Widerrufsrecht = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Скролимо в верх сторінки
  }, []);
  return (
    <div>
      <Helmet>
        <title>Widerrufsrecht – HIXA – DSG Getriebe Reparatur & Wartung</title>
      </Helmet>
      <Nav />
      <h2 className={`sectionContainer ${styles.title}`}>Widerrufsrecht</h2>
      <div className="container sectionContainer sectionContainerWhite">
        <p className={styles.infoPageText}>
          <span className={styles.bold}>Aktualisiert:</span> May 2025
        </p>

        <ol className={styles.infoPageList}>
          <li className={styles.infoPageItem}>
            <span className={styles.bold}>
              Widerrufsrecht für Verbraucher bei Warenlieferung
            </span>
          </li>
        </ol>

        <p className={styles.infoPageText}>
          (Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu
          Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch
          ihrer selbstständigen beruflichen Tätigkeit zugerechnet werden
          können.)
        </p>

        <h3 className={styles.infoPageHeader}>Widerrufsbelehrung</h3>

        <h4 className={styles.infoPageSubHeader}>A.1. Widerrufsrecht</h4>
        <p className={styles.infoPageText}>
          Sie haben das Recht, binnen 14 Tagen ohne Angabe von Gründen diesen
          Vertrag zu widerrufen.
        </p>
        <p className={styles.infoPageText}>
          Die Widerrufsfrist beträgt 14 Tage ab dem Tag,
        </p>
        <ul className={styles.infoPageList}>
          <li className={styles.infoPageItem}>
            an dem Sie oder ein von Ihnen benannter Dritter, der nicht der
            Beförderer ist, die Waren in Besitz genommen haben bzw. hat, sofern
            Sie eine oder mehrere Waren im Rahmen einer einheitlichen Bestellung
            bestellt haben und diese einheitlich geliefert wird bzw. werden;
          </li>
          <li className={styles.infoPageItem}>
            an dem Sie oder ein von Ihnen benannter Dritter, der nicht der
            Beförderer ist, die letzte Ware in Besitz genommen haben bzw. hat,
            sofern Sie mehrere Waren im Rahmen einer einheitlichen Bestellung
            bestellt haben und diese getrennt geliefert werden;
          </li>
          <li className={styles.infoPageItem}>
            an dem Sie oder ein von Ihnen benannter Dritter, der nicht der
            Beförderer ist, die letzte Teilsendung oder das letzte Stück in
            Besitz genommen haben bzw. hat, sofern Sie eine Ware bestellt haben,
            die in mehreren Teilsendungen oder Stücken geliefert wird;
          </li>
        </ul>
        <p className={styles.infoPageText}>
          Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (HIXA GmbH ,
          Geschäftsführerin Anna Likhnenko, HIXA GmbH Neukirchstraße 74, 13089
          Berlin, Telefonnummer: +49 30 520 151 91, E-Mail-Adresse:
          kunden@hixa.eu) mittels einer eindeutigen Erklärung (z.B. ein mit der
          Post versandter Brief, Telefax oder E-Mail) über Ihren Entschluss,
          diesen Vertrag zu widerrufen, informieren. Sie können dafür das
          beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht
          vorgeschrieben ist.
        </p>
        <p className={styles.infoPageText}>
          Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung
          über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist
          absenden.
        </p>

        <h4 className={styles.infoPageSubHeader}>A.2. Folgen des Widerrufs</h4>
        <p className={styles.infoPageText}>
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen,
          die wir von Ihnen erhalten haben, ausschließlich der Lieferkosten,
          unverzüglich und spätestens binnen 14 Tagen ab dem Tag zurückzuzahlen,
          an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns
          eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe
          Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt
          haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes
          vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung
          Entgelte berechnet.
        </p>
        <p className={styles.infoPageText}>
          Wir können die Rückzahlung verweigern, bis wir die Waren wieder
          zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass
          Sie die Waren zurückgesandt haben, je nachdem, welches der frühere
          Zeitpunkt ist.
        </p>
        <p className={styles.infoPageText}>
          Sie haben die Waren unverzüglich und in jedem Fall spätestens binnen
          14 Tagen ab dem Tag, an dem Sie uns über den Widerruf dieses Vertrags
          unterrichten, an uns zurückzusenden oder zu übergeben. Die Frist ist
          gewahrt, wenn Sie die Waren vor Ablauf der Frist von 14 Tagen
          absenden.
        </p>
        <p className={styles.infoPageText}>
          Sie tragen die unmittelbaren Kosten der Rücksendung der Waren.
        </p>
        <p className={styles.infoPageText}>
          Sie müssen für einen etwaigen Wertverlust der Waren nur aufkommen,
          wenn dieser Wertverlust auf einen zur Prüfung der Beschaffenheit,
          Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang
          mit ihnen zurückzuführen ist.
        </p>

        <h4 className={styles.infoPageSubHeader}>
          A.3. Ausschluss- bzw. Erlöschensgründe
        </h4>
        <p className={styles.infoPageText}>
          Das Widerrufsrecht besteht nicht bei Verträgen zur Lieferung von
          Waren, die nicht vorgefertigt sind und für deren Herstellung eine
          individuelle Auswahl oder Bestimmung durch den Verbraucher maßgeblich
          ist oder die eindeutig auf die persönlichen Bedürfnisse des
          Verbrauchers zugeschnitten sind.
        </p>

        <h3 className={styles.infoPageHeader}>
          Widerrufsrecht für Verbraucher bei Dienstleistungen
        </h3>
        <p className={styles.infoPageText}>
          (Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu
          Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch
          ihrer selbstständigen beruflichen Tätigkeit zugerechnet werden
          können.)
        </p>
        <h2 className={styles.infoPageHeader}>
          Ausschluss des Rückgaberechts für bestimmte Waren
        </h2>
        <p className={styles.infoPageText}>
          Bestimmte Waren sind aufgrund ihrer Beschaffenheit vom Widerrufsrecht
          ausgeschlossen. Dazu gehören insbesondere:
        </p>
        <p className={styles.infoPageText}>
          1.&nbsp;<strong>Sonderaufträge:</strong>&nbsp;Waren, die speziell nach
          den individuellen Vorgaben des Kunden angefertigt, angepasst oder auf
          persönliche Bedürfnisse zugeschnitten wurden. Diese beinhalten
          insbesondere Teile, die nach Maß, individuellen technischen
          Anforderungen oder persönlichen Wünschen des Kunden gefertigt wurden.
        </p>
        <p className={styles.infoPageText}>
          2.&nbsp;<strong>Elektronische Komponenten:</strong>&nbsp;Elektronische
          Bauteile und Steuergeräte, die nach der Öffnung oder Montage nicht
          mehr im originalen Zustand sind, unterliegen ebenfalls nicht dem
          Widerrufsrecht. Dies gilt insbesondere dann, wenn das Produkt bereits
          in ein Fahrzeug eingebaut wurde oder eine individuelle Anpassung
          erfordert.
        </p>
        <p className={styles.infoPageText}>
          2a.&nbsp;<strong>Individuell programmierte Mechatronik:</strong>
          &nbsp;Mechatronik-Steuergeräte, die individuell für den Kunden
          programmiert oder angepasst werden, sind vom Rückgaberecht und
          Umtausch vollständig ausgeschlossen (§ 312g Abs. 2 Nr. 1 BGB). Im
          Garantiefall verpflichtet sich HIXA GmbH nicht zur Fehleranalyse am
          Fahrzeug des Kunden. Stattdessen kann dem Kunden angeboten werden, das
          gelieferte Teil in ein firmeneigenes Referenzfahrzeug einzubauen und
          dessen Funktionsfähigkeit per Video zu dokumentieren. Für diese
          zusätzliche Dienstleistung wird ein gesondertes Arbeitsentgelt für den
          Mechatroniker berechnet. Eine telefonische technische Beratung oder
          Ferndiagnose gehört ausdrücklich nicht zum Leistungsumfang beim
          Verkauf von Ersatzteilen.
        </p>
        <p className={styles.infoPageText}>
          2b.&nbsp;
          <strong>
            Rücktrittsgebühr bei individuell programmierter Mechatronik:
          </strong>
          <br />
          Sollte der Kunde nach der Bestätigung unseres Angebots und dem Beginn
          der individuellen Programmierung des Mechatronik-Steuergeräts vom
          Vertrag zurücktreten wollen, behält sich die HIXA GmbH gemäß § 649 BGB
          (Kündigung des Werkvertrags) das Recht vor, eine Rücktrittsgebühr in
          Höhe von 30 % – 40 % des vereinbarten Gesamtpreises zu berechnen.
          <br />
          Diese Gebühr deckt die bereits erbrachten Arbeitsleistungen,
          insbesondere die Softwareprogrammierung, Kalibrierung und Vorbereitung
          des Steuergeräts, sowie die hierfür eingesetzten Materialien und
          Ressourcen.
          <br />
          Die Berechnung erfolgt unabhängig davon, ob das Steuergerät bereits
          ausgeliefert wurde oder sich noch im Produktionsprozess befindet.
          <br />
          Gemäß § 312g Abs. 2 Nr. 1 und Nr. 3 des Bürgerlichen Gesetzbuches
          (BGB) besteht kein Widerrufsrecht für Waren, die nach
          Kundenspezifikation angefertigt oder eindeutig auf die persönlichen
          Bedürfnisse des Kunden zugeschnitten sind, sowie für Waren, die
          aufgrund ihrer Beschaffenheit untrennbar mit anderen Gütern vermischt
          oder in ein Fahrzeug integriert wurden.
          <br />
          Damit wird klargestellt, dass individuell programmierte Mechatroniken
          und elektronische Steuergeräte, die nach Kundenvorgaben angepasst
          werden, vom Widerruf, Rückgaberecht und Umtausch ausgeschlossen sind.
        </p>

        <p className={styles.infoPageText}>
          3.&nbsp;<strong>Gebrauchte und instandgesetzte Teile:</strong>
          &nbsp;Teile, die bereits verwendet wurden und nach der Instandsetzung
          (Reparatur) nicht mehr im ursprünglichen Zustand sind, fallen nicht
          unter das allgemeine Widerrufsrecht.
        </p>
        <p className={styles.infoPageText}>
          Diese Ausschlüsse basieren auf den gesetzlichen Bestimmungen,
          insbesondere § 312g Abs. 2 BGB, wonach Waren, die nicht vorgefertigt
          sind und eindeutig auf die persönlichen Bedürfnisse des Verbrauchers
          zugeschnitten wurden, vom Widerrufsrecht ausgenommen sind.
        </p>
        <h4 className={styles.infoPageSubHeader}>B.1. Widerrufsrecht</h4>
        <p className={styles.infoPageText}>
          Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen
          diesen Vertrag zu widerrufen.
        </p>
        <p className={styles.infoPageText}>
          Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des
          Vertragsabschlusses.
        </p>

        <h4 className={styles.infoPageSubHeader}>B.2. Folgen des Widerrufs</h4>
        <p className={styles.infoPageText}>
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen,
          die wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit
          Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie
          eine andere Art der Lieferung als die von uns angebotene, günstigste
          Standardlieferung gewählt haben), unverzüglich und spätestens binnen
          vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über
          Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese
          Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der
          ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen
          wurde ausdrücklich etwas anderes vereinbart; in keinem Fall werden
          Ihnen wegen dieser Rückzahlung Entgelte berechnet.
        </p>

        <h4 className={styles.infoPageSubHeader}>
          B.3. Ausschluss- bzw. Erlöschensgründe
        </h4>
        <p className={styles.infoPageText}>
          Das Widerrufsrecht erlischt bei Verträgen zur Erbringung von
          Dienstleistungen, wenn der Unternehmer die Dienstleistung vollständig
          erbracht hat und mit der Ausführung der Dienstleistung erst begonnen
          hat, nachdem der Verbraucher dazu seine ausdrückliche Zustimmung
          gegeben hat und gleichzeitig seine Kenntnis davon bestätigt hat, dass
          er sein Widerrufsrecht bei vollständiger Vertragserfüllung durch den
          Unternehmer verliert.
        </p>

        <h3 className={styles.infoPageHeader}>Muster-Widerrufsformular</h3>
        <p className={styles.infoPageText}>
          (Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses
          Formular aus und senden es zurück.)
        </p>
        <p className={styles.infoPageText}>
          – An HIXA GmbH , Neukirchstraße 74, 13089 Berlin, Telefonnummer: +49
          30 520 151 91, E-Mail-Adresse: kunden@hixa.eu:
        </p>
        <p className={styles.infoPageText}>
          – Hiermit widerrufe(n) ich / wir (*) den von mir / uns (*)
          abgeschlossenen Vertrag über den Kauf der folgenden Waren (*) /
          Erbringung der folgenden Dienstleistung (*)
        </p>
        <p className={styles.infoPageText}>
          – Bestellt am (*) / erhalten am (*)
        </p>
        <p className={styles.infoPageText}>– Name des / der Verbraucher(s)</p>
        <p className={styles.infoPageText}>
          – Anschrift des / der Verbraucher(s)
        </p>
        <p className={styles.infoPageText}>
          – Unterschrift des / der Verbraucher(s) (nur bei Mitteilung auf
          Papier)
        </p>
        <p className={styles.infoPageText}>– Datum</p>
        <p className={styles.infoPageText}>(*) Unzutreffendes streichen.</p>

        <h3 className={styles.infoPageHeader}>Rückerstattungen</h3>
        <p className={styles.infoPageText}>
          HIXA GmbH gewährt keine Rückerstattungen für Reparaturaufträge und
          Datenübertragung.
        </p>

        <h3 className={styles.infoPageHeader}>Stornierung</h3>
        <p className={styles.infoPageText}>
          Nach der Annahme eines Reparaturauftrags leitet HIXA GmbH die
          Reparatur ein. Danach können Reparaturaufträge nicht mehr storniert
          werden. Sie sind auch nicht berechtigt, vom Vertrag zurückzutreten.
        </p>
        <p className={styles.infoPageText}>
          – Hiermit widerrufe(n) ich / wir (*) den von mir / uns (*)
          abgeschlossenen Vertrag über den Kauf der folgenden Waren (*) /
        </p>
      </div>
      <CookiePopupButton></CookiePopupButton>
      <Footer />
    </div>
  );
};

export default Widerrufsrecht;
